import React, {useEffect, useState} from 'react';
import {CheckoutButton} from '../../../../../common/components/CheckoutButton/CheckoutButton';
import {useControllerProps} from '../../../../../domain/controllers/ControllerContext';
import s from './CheckoutButtons.scss';
import settingsParams from '../../../settingsParams';
import {useSettingsWithDefaults} from '../../../../../hooks/useSettingsWithDefaults';
import {ExpressButtons} from '../../../../../common/components/ExpressButtons';

export enum CheckoutButtonsDataHook {
  Default = 'CheckoutButtons.default',
  Top = 'CheckoutButtons.topView',
  Wrapper = 'CheckoutButtons.Wrapper',
}

interface CheckoutButtonsProps {
  isOnTop?: boolean;
}

export function CheckoutButtons(props: CheckoutButtonsProps) {
  const {shouldShowExpressCheckout} = useControllerProps().cashierExpressStore;
  const {isSummaryUpdating, reportCheckoutButtonPresented} = useControllerProps().cartStore;
  const {isCheckoutButtonDisabled, isNavigationToCheckoutInProcess} = useControllerProps().navigationStore;
  const {getSettingsWithDefaults} = useSettingsWithDefaults();
  const [isLoaded, setIsLoaded] = useState(false);
  const {isOnTop} = props;
  const dataHook = isOnTop ? CheckoutButtonsDataHook.Top : CheckoutButtonsDataHook.Default;

  useEffect(() => {
    setIsLoaded(true);
    reportCheckoutButtonPresented(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderExpressCheckout = () => {
    if (isLoaded && shouldShowExpressCheckout) {
      return (
        <div className={s.expressButtonsContainer}>
          <div className={s.expressCheckoutButtonsVisibility}>
            <ExpressButtons dataHook={CheckoutButtonsDataHook.Wrapper} />
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div data-hook={dataHook} className={s.checkoutButtons}>
      <CheckoutButton
        disabled={isCheckoutButtonDisabled || isSummaryUpdating}
        text={getSettingsWithDefaults(settingsParams.CART_BUTTON_TEXT)}
        isNavigationToCheckoutInProcess={isNavigationToCheckoutInProcess}
      />
      {renderExpressCheckout()}
    </div>
  );
}
